import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Button from 'components/common/Button';
import routePaths from 'router/route-paths';
import settings from 'config/settings';
import { applicationTypes } from 'constants/constants';
import Navbar from './Navbar';
import s from './Navbar.module.scss';

const LegalLinks = ({ className }) => (
  <nav className={className} aria-label="Legal">
    <Link to={routePaths.termsOfUse} className="link">
      <FormattedMessage id="app.terms_of_use" />
    </Link>
    <Link to={routePaths.dataProcessing} className="link">
      <FormattedMessage id="app.data_processing" />
    </Link>
    <a href={settings.impressumUrl} className="link" target="_blank" rel="noopener noreferrer">
      <FormattedMessage id="app.impressum" />
    </a>
  </nav>
);

const AuthNavbar = ({ hideSignIn }) => (
  <Navbar hideHamburger fluid auth>
    <LegalLinks className={s.desktopLegalLinks} />
    <details className={s.mobileLegalMenu}>
      <summary className="link">
        <FormattedMessage id="app.legal" />
      </summary>
      <LegalLinks className={s.mobileLegalLinks} />
    </details>
    {!hideSignIn && settings.applicationType !== applicationTypes.expressLoan ? (
      <Link to={routePaths.login} className="link">
        <Button color="outline" className={s.loginBtn}>
          <FormattedMessage id="auth.sign_in_submit" />
        </Button>
      </Link>
    ) : null}
  </Navbar>
);
export default AuthNavbar;
